import React from 'react'
import styles from '../../styles/pages/user/content-buyer-accounting.module.scss'
import { Backdrop, Box, Button, ButtonGroup, CircularProgress, InputAdornment, List, ListItem, OutlinedInput, Snackbar, Stack, Typography } from '@mui/material'
import DarkbackIcon from '../../ui/Icons/DarkbackIcon'
import DarksaveIcon from '../../ui/Icons/DarksaveIcon'
import EyeviewIcon from '../../ui/Icons/EyeviewIcon'
import DeleteIcon from '../../ui/Icons/DeleteIcon'

const ContentbuyerAccountingPaymentConfirm = () => {
    const [input, setinput] = React.useState({
        name: '',
    })
    const [snackOpen, setSnackOpen] = React.useState(false);

    const handleClick = () => {
        setSnackOpen(true);
    };

    const handleClose = (
        event,
        reason
    ) => {
        if (reason === "clickaway") {
            return;
        }

        setSnackOpen(false);
    };
    return (
        <>
            <List disablePadding className={styles.paymentTop} >
                <ListItem disablePadding>
                    <Typography variant='body1'>Request date:</Typography>
                    <Typography variant='caption'>January 25, 2022</Typography>
                </ListItem>
                <ListItem disablePadding>
                    <Typography variant='body1'>Amount requested:</Typography>
                    <Typography variant='caption'>$650</Typography>
                </ListItem>
                <ListItem disablePadding>
                    <Typography variant='body1'>PayPal:</Typography>
                    <Typography variant='caption'>paypal@viralsnare.com</Typography>
                </ListItem>
            </List>
            <Box className={styles.paymentBottomSec}>
                <List disablePadding>
                    <ListItem disablePadding>
                        <Typography variant='overline'>Amount received:</Typography>
                        <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.receiveRight}>
                            <OutlinedInput autoComplete='off' startAdornment={<InputAdornment position="start">$</InputAdornment>} />
                            <ButtonGroup>
                                <Button><DarkbackIcon /></Button>
                                <Button><DarksaveIcon /></Button>
                            </ButtonGroup>
                        </Stack>
                    </ListItem>
                    <ListItem disablePadding>
                        <Typography variant='overline'>Payment Receipt:</Typography>
                        <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.receiveRight}>
                            {input?.name !== '' ? (
                                <Stack direction={'row'} alignItems={'center'} flexWrap={'wrap'} className={styles.showInput}>
                                    <Typography variant='caption'>{input?.name}</Typography>
                                    <ButtonGroup>
                                        <Button><EyeviewIcon /></Button>
                                        <Button><DeleteIcon /></Button>
                                    </ButtonGroup>
                                </Stack>
                            ) : (
                                <Box className="attachFileinput">
                                    <input type="file" id="upload" hidden onChange={(e) => setinput({ ...input, name: e.target.files[0].name })} />
                                    <label htmlFor="upload"> Attach File</label>
                                </Box>
                            )}

                        </Stack>
                    </ListItem>
                </List>
            </Box>
            <Button className={styles.paymentConfirmBtn} onClick={handleClick}>Confirm Payment</Button>

            <Backdrop
                open={snackOpen}
                sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
                onClick={handleClose}
            >
                <Snackbar
                    open={snackOpen}
                    autoHideDuration={100000}
                    onClose={handleClose}
                    message={
                        <>
                            <CircularProgress size={20} thickness={7} color="inherit" />
                            <span className='textSave'>Confirming</span>
                        </>
                    }
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    ContentProps={{
                        sx: {
                            minWidth: "219px !important",
                            background: "#000",
                            boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.5)",
                            height: "45px",
                            justifyContent: "center",
                            "& .MuiSnackbarContent-message": {
                                fontWeight: "500",
                                fontSize: "13px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                paddingTop: "2px",
                                "& .textSave": {
                                    display: "inline-block",
                                    fontSize: "13px",
                                    fontWeight: "600",
                                    paddingLeft: "13px"
                                }
                            },
                        },
                    }}
                />
            </Backdrop>
        </>
    )
}

export default ContentbuyerAccountingPaymentConfirm